import * as AllViews from '@/views';

const routes = [
    {
        path: '*',
        redirect: 'logins',
    },
    {
        path: '/abscences',
        name: 'abscences',
        component: () => AllViews.ReadAbscences(),
        meta: {
            pageTitle: 'Abscences',
            breadcrumb: [
                {
                    text: 'Abscences',
                    active: true,
                },
            ],
        },
    },//
    {
        path: '/achatsforfaits',
        name: 'achatsforfaits',
        component: () => AllViews.ReadAchatsforfaits(),
        meta: {
            pageTitle: 'Achatsforfaits',
            breadcrumb: [
                {
                    text: 'Achatsforfaits',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/actions',
        name: 'actions',
        component: () => AllViews.ReadActions(),
        meta: {
            pageTitle: 'Actions',
            breadcrumb: [
                {
                    text: 'Actions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/alarms',
        name: 'alarms',
        component: () => AllViews.ReadAlarms(),
        meta: {
            pageTitle: 'Alarms',
            breadcrumb: [
                {
                    text: 'Alarms',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/alldatas',
        name: 'alldatas',
        component: () => AllViews.ReadAlldatas(),
        meta: {
            pageTitle: 'Alldatas',
            breadcrumb: [
                {
                    text: 'Alldatas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/analysespointeuses',
        name: 'analysespointeuses',
        component: () => AllViews.ReadAnalysespointeuses(),
        meta: {
            pageTitle: 'Analysespointeuses',
            breadcrumb: [
                {
                    text: 'Analysespointeuses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/approvisionementdetails',
        name: 'approvisionementdetails',
        component: () => AllViews.ReadApprovisionementdetails(),
        meta: {
            pageTitle: 'Approvisionementdetails',
            breadcrumb: [
                {
                    text: 'Approvisionementdetails',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/assignations',
        name: 'assignations',
        component: () => AllViews.ReadAssignations(),
        meta: {
            pageTitle: 'Assignations',
            breadcrumb: [
                {
                    text: 'Assignations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/badges',
        name: 'badges',
        component: () => AllViews.ReadBadges(),
        meta: {
            pageTitle: 'Badges',
            breadcrumb: [
                {
                    text: 'Badges',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/bagages',
        name: 'bagages',
        component: () => AllViews.ReadBagages(),
        meta: {
            pageTitle: 'Bagages',
            breadcrumb: [
                {
                    text: 'Bagages',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/balises',
        name: 'balises',
        component: () => AllViews.ReadBalises(),
        meta: {
            pageTitle: 'Balises',
            breadcrumb: [
                {
                    text: 'Balises',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/cartes',
        name: 'cartes',
        component: () => AllViews.ReadCartes(),
        meta: {
            pageTitle: 'Cartes',
            breadcrumb: [
                {
                    text: 'Cartes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/categories',
        name: 'categories',
        component: () => AllViews.ReadCategories(),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [
                {
                    text: 'Categories',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/clients',
        name: 'clients',
        component: () => AllViews.ReadClients(),
        meta: {
            pageTitle: 'Clients',
            breadcrumb: [
                {
                    text: 'Clients',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/configurations',
        name: 'configurations',
        component: () => AllViews.ReadConfigurations(),
        meta: {
            pageTitle: 'Configurations',
            breadcrumb: [
                {
                    text: 'Configurations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/conges',
        name: 'conges',
        component: () => AllViews.ReadConges(),
        meta: {
            pageTitle: 'Conges',
            breadcrumb: [
                {
                    text: 'Conges',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/contrats',
        name: 'contrats',
        component: () => AllViews.ReadContrats(),
        meta: {
            pageTitle: 'Contrats',
            breadcrumb: [
                {
                    text: 'Contrats',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/contratsclients',
        name: 'contratsclients',
        component: () => AllViews.ReadContratsclients(),
        meta: {
            pageTitle: 'Contratsclients',
            breadcrumb: [
                {
                    text: 'Contratsclients',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/controlles',
        name: 'controlles',
        component: () => AllViews.ReadControlles(),
        meta: {
            pageTitle: 'Controlles',
            breadcrumb: [
                {
                    text: 'Controlles',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/controlleursacces',
        name: 'controlleursacces',
        component: () => AllViews.ReadControlleursacces(),
        meta: {
            pageTitle: 'Controlleursacces',
            breadcrumb: [
                {
                    text: 'Controlleursacces',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/credits',
        name: 'credits',
        component: () => AllViews.ReadCredits(),
        meta: {
            pageTitle: 'Credits',
            breadcrumb: [
                {
                    text: 'Credits',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/cruds',
        name: 'cruds',
        component: () => AllViews.ReadCruds(),
        meta: {
            pageTitle: 'Cruds',
            breadcrumb: [
                {
                    text: 'Cruds',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/daysprogrammes',
        name: 'daysprogrammes',
        component: () => AllViews.ReadDaysprogrammes(),
        meta: {
            pageTitle: 'Daysprogrammes',
            breadcrumb: [
                {
                    text: 'Daysprogrammes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/daysprogrammestaches',
        name: 'daysprogrammestaches',
        component: () => AllViews.ReadDaysprogrammestaches(),
        meta: {
            pageTitle: 'Daysprogrammestaches',
            breadcrumb: [
                {
                    text: 'Daysprogrammestaches',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/debits',
        name: 'debits',
        component: () => AllViews.ReadDebits(),
        meta: {
            pageTitle: 'Debits',
            breadcrumb: [
                {
                    text: 'Debits',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/dependances',
        name: 'dependances',
        component: () => AllViews.ReadDependances(),
        meta: {
            pageTitle: 'Dependances',
            breadcrumb: [
                {
                    text: 'Dependances',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/deplacements',
        name: 'deplacements',
        component: () => AllViews.ReadDeplacements(),
        meta: {
            pageTitle: 'Deplacements',
            breadcrumb: [
                {
                    text: 'Deplacements',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/deploiementspointeusesmoyenstransports',
        name: 'deploiementspointeusesmoyenstransports',
        component: () => AllViews.ReadDeploiementspointeusesmoyenstransports(),
        meta: {
            pageTitle: 'Deploiementspointeusesmoyenstransports',
            breadcrumb: [
                {
                    text: 'Deploiementspointeusesmoyenstransports',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/devicesandroids',
        name: 'devicesandroids',
        component: () => AllViews.ReadDevicesandroids(),
        meta: {
            pageTitle: 'Devicesandroids',
            breadcrumb: [
                {
                    text: 'Devicesandroids',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/directions',
        name: 'directions',
        component: () => AllViews.ReadDirections(),
        meta: {
            pageTitle: 'Directions',
            breadcrumb: [
                {
                    text: 'Directions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/echelons',
        name: 'echelons',
        component: () => AllViews.ReadEchelons(),
        meta: {
            pageTitle: 'Echelons',
            breadcrumb: [
                {
                    text: 'Echelons',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/entreprises',
        name: 'entreprises',
        component: () => AllViews.ReadEntreprises(),
        meta: {
            pageTitle: 'Entreprises',
            breadcrumb: [
                {
                    text: 'Entreprises',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/etapes',
        name: 'etapes',
        component: () => AllViews.ReadEtapes(),
        meta: {
            pageTitle: 'Etapes',
            breadcrumb: [
                {
                    text: 'Etapes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exports',
        name: 'exports',
        component: () => AllViews.ReadExports(),
        meta: {
            pageTitle: 'Exports',
            breadcrumb: [
                {
                    text: 'Exports',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportsdetails',
        name: 'exportsdetails',
        component: () => AllViews.ReadExportsdetails(),
        meta: {
            pageTitle: 'Exportsdetails',
            breadcrumb: [
                {
                    text: 'Exportsdetails',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/extrasdatas',
        name: 'extrasdatas',
        component: () => AllViews.ReadExtrasdatas(),
        meta: {
            pageTitle: 'Extrasdatas',
            breadcrumb: [
                {
                    text: 'Extrasdatas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/files',
        name: 'files',
        component: () => AllViews.ReadFiles(),
        meta: {
            pageTitle: 'Files',
            breadcrumb: [
                {
                    text: 'Files',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/fonctions',
        name: 'fonctions',
        component: () => AllViews.ReadFonctions(),
        meta: {
            pageTitle: 'Fonctions',
            breadcrumb: [
                {
                    text: 'Fonctions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/forfaits',
        name: 'forfaits',
        component: () => AllViews.ReadForfaits(),
        meta: {
            pageTitle: 'Forfaits',
            breadcrumb: [
                {
                    text: 'Forfaits',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/headselements',
        name: 'headselements',
        component: () => AllViews.ReadHeadselements(),
        meta: {
            pageTitle: 'Headselements',
            breadcrumb: [
                {
                    text: 'Headselements',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/historiques',
        name: 'historiques',
        component: () => AllViews.ReadHistoriques(),
        meta: {
            pageTitle: 'Historiques',
            breadcrumb: [
                {
                    text: 'Historiques',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/homes',
        name: 'homes',
        component: () => AllViews.ReadHomes(),
        meta: {
            pageTitle: 'Homes',
            breadcrumb: [
                {
                    text: 'Homes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/horaireagents',
        name: 'horaireagents',
        component: () => AllViews.ReadHoraireagents(),
        meta: {
            pageTitle: 'Horaireagents',
            breadcrumb: [
                {
                    text: 'Horaireagents',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/horaires',
        name: 'horaires',
        component: () => AllViews.ReadHoraires(),
        meta: {
            pageTitle: 'Horaires',
            breadcrumb: [
                {
                    text: 'Horaires',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/horairesglobalspostes',
        name: 'horairesglobalspostes',
        component: () => AllViews.ReadHorairesglobalspostes(),
        meta: {
            pageTitle: 'Horairesglobalspostes',
            breadcrumb: [
                {
                    text: 'Horairesglobalspostes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/horairestypespostes',
        name: 'horairestypespostes',
        component: () => AllViews.ReadHorairestypespostes(),
        meta: {
            pageTitle: 'Horairestypespostes',
            breadcrumb: [
                {
                    text: 'Horairestypespostes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/horairestypessites',
        name: 'horairestypessites',
        component: () => AllViews.ReadHorairestypessites(),
        meta: {
            pageTitle: 'Horairestypessites',
            breadcrumb: [
                {
                    text: 'Horairestypessites',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/identifications',
        name: 'identifications',
        component: () => AllViews.ReadIdentifications(),
        meta: {
            pageTitle: 'Identifications',
            breadcrumb: [
                {
                    text: 'Identifications',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/imports',
        name: 'imports',
        component: () => AllViews.ReadImports(),
        meta: {
            pageTitle: 'Imports',
            breadcrumb: [
                {
                    text: 'Imports',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/jobs',
        name: 'jobs',
        component: () => AllViews.ReadJobs(),
        meta: {
            pageTitle: 'Jobs',
            breadcrumb: [
                {
                    text: 'Jobs',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/journalPointage',
        name: 'journals',
        component: () => AllViews.Imports.ReadHistorique(),
        meta: {
            requiresAuth: true,
            pageTitle: 'Journal pointages ',
            hideCreate: true,
            breadcrumb: [
                {
                    text: 'Journals',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/journalspointages',
        name: 'journals2',
        component: () => AllViews.Imports.ReadHistorique(),
        meta: {
            requiresAuth: true,
            pageTitle: 'Journal pointages ( Bis )',
            hideCreate: true,
            breadcrumb: [
                {
                    text: 'Journals',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/joursferies',
        name: 'joursferies',
        component: () => AllViews.ReadJoursferies(),
        meta: {
            pageTitle: 'Joursferies',
            breadcrumb: [
                {
                    text: 'Joursferies',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/lignes',
        name: 'lignes',
        component: () => AllViews.ReadLignes(),
        meta: {
            pageTitle: 'Lignes',
            breadcrumb: [
                {
                    text: 'Lignes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/lignesmoyenstransports',
        name: 'lignesmoyenstransports',
        component: () => AllViews.ReadLignesmoyenstransports(),
        meta: {
            pageTitle: 'Lignesmoyenstransports',
            breadcrumb: [
                {
                    text: 'Lignesmoyenstransports',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/listingsetats',
        name: 'listingsetats',
        component: () => AllViews.ReadListingsetats(),
        meta: {
            pageTitle: 'Listingsetats',
            breadcrumb: [
                {
                    text: 'Listingsetats',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/listingsvalider0stats',
        name: 'listingsvalider0stats',
        component: () => AllViews.ReadListingsvalider0stats(),
        meta: {
            pageTitle: 'Listingsvalider0stats',
            breadcrumb: [
                {
                    text: 'Listingsvalider0stats',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/logs',
        name: 'logs',
        component: () => AllViews.ReadLogs(),
        meta: {
            pageTitle: 'Logs',
            breadcrumb: [
                {
                    text: 'Logs',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/maintenances',
        name: 'maintenances',
        component: () => AllViews.ReadMaintenances(),
        meta: {
            pageTitle: 'Maintenances',
            breadcrumb: [
                {
                    text: 'Maintenances',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/maps',
        name: 'maps',
        component: () => AllViews.ReadMaps(),
        meta: {
            pageTitle: 'Maps',
            breadcrumb: [
                {
                    text: 'Maps',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/matrimoniales',
        name: 'matrimoniales',
        component: () => AllViews.ReadMatrimoniales(),
        meta: {
            pageTitle: 'Matrimoniales',
            breadcrumb: [
                {
                    text: 'Matrimoniales',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/menus',
        name: 'menus',
        component: () => AllViews.ReadMenus(),
        meta: {
            pageTitle: 'Menus',
            breadcrumb: [
                {
                    text: 'Menus',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/model_has_permissions',
        name: 'model_has_permissions',
        component: () => AllViews.ReadModel_has_permissions(),
        meta: {
            pageTitle: 'Model_has_permissions',
            breadcrumb: [
                {
                    text: 'Model_has_permissions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/modelslistings',
        name: 'modelslistings',
        component: () => AllViews.ReadModelslistings(),
        meta: {
            pageTitle: 'Modelslistings',
            breadcrumb: [
                {
                    text: 'Modelslistings',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/moyenstransports',
        name: 'moyenstransports',
        component: () => AllViews.ReadMoyenstransports(),
        meta: {
            pageTitle: 'Moyenstransports',
            breadcrumb: [
                {
                    text: 'Moyenstransports',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/moyenstransportspointeuses',
        name: 'moyenstransportspointeuses',
        component: () => AllViews.ReadMoyenstransportspointeuses(),
        meta: {
            pageTitle: 'Moyenstransportspointeuses',
            breadcrumb: [
                {
                    text: 'Moyenstransportspointeuses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/nationalites',
        name: 'nationalites',
        component: () => AllViews.ReadNationalites(),
        meta: {
            pageTitle: 'Nationalites',
            breadcrumb: [
                {
                    text: 'Nationalites',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/oauth_access_tokens',
        name: 'oauth_access_tokens',
        component: () => AllViews.ReadOauth_access_tokens(),
        meta: {
            pageTitle: 'Oauth_access_tokens',
            breadcrumb: [
                {
                    text: 'Oauth_access_tokens',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/oauth_auth_codes',
        name: 'oauth_auth_codes',
        component: () => AllViews.ReadOauth_auth_codes(),
        meta: {
            pageTitle: 'Oauth_auth_codes',
            breadcrumb: [
                {
                    text: 'Oauth_auth_codes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/oauth_clients',
        name: 'oauth_clients',
        component: () => AllViews.ReadOauth_clients(),
        meta: {
            pageTitle: 'Oauth_clients',
            breadcrumb: [
                {
                    text: 'Oauth_clients',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/oauth_personal_access_clients',
        name: 'oauth_personal_access_clients',
        component: () => AllViews.ReadOauth_personal_access_clients(),
        meta: {
            pageTitle: 'Oauth_personal_access_clients',
            breadcrumb: [
                {
                    text: 'Oauth_personal_access_clients',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/oauth_refresh_tokens',
        name: 'oauth_refresh_tokens',
        component: () => AllViews.ReadOauth_refresh_tokens(),
        meta: {
            pageTitle: 'Oauth_refresh_tokens',
            breadcrumb: [
                {
                    text: 'Oauth_refresh_tokens',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/passagesrondes',
        name: 'passagesrondes',
        component: () => AllViews.ReadPassagesrondes(),
        meta: {
            pageTitle: 'Passagesrondes',
            breadcrumb: [
                {
                    text: 'Passagesrondes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/pastilles',
        name: 'pastilles',
        component: () => AllViews.ReadPastilles(),
        meta: {
            pageTitle: 'Pastilles',
            breadcrumb: [
                {
                    text: 'Pastilles',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/permissions',
        name: 'permissions',
        component: () => AllViews.ReadPermissions(),
        meta: {
            pageTitle: 'Permissions',
            breadcrumb: [
                {
                    text: 'Permissions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/perms',
        name: 'perms',
        component: () => AllViews.ReadPerms(),
        meta: {
            pageTitle: 'Perms',
            breadcrumb: [
                {
                    text: 'Perms',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/pointages',
        name: 'pointages',
        component: () => AllViews.ReadPointages(),
        meta: {
            pageTitle: 'Pointages',
            breadcrumb: [
                {
                    text: 'Pointages',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/pointeuses',
        name: 'pointeuses',
        component: () => AllViews.ReadPointeuses(),
        meta: {
            pageTitle: 'Pointeuses',
            breadcrumb: [
                {
                    text: 'Pointeuses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/pointeusestransactions',
        name: 'pointeusestransactions',
        component: () => AllViews.ReadPointeusestransactions(),
        meta: {
            pageTitle: 'Pointeusestransactions',
            breadcrumb: [
                {
                    text: 'Pointeusestransactions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/points',
        name: 'points',
        component: () => AllViews.ReadPoints(),
        meta: {
            pageTitle: 'Points',
            breadcrumb: [
                {
                    text: 'Points',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/positions',
        name: 'positions',
        component: () => AllViews.ReadPositions(),
        meta: {
            pageTitle: 'Positions',
            breadcrumb: [
                {
                    text: 'Positions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/postes',
        name: 'postes',
        component: () => AllViews.ReadPostes(),
        meta: {
            pageTitle: 'Postes',
            breadcrumb: [
                {
                    text: 'Postes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/postesarticles',
        name: 'postesarticles',
        component: () => AllViews.ReadPostesarticles(),
        meta: {
            pageTitle: 'Postesarticles',
            breadcrumb: [
                {
                    text: 'Postesarticles',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/postesglobals',
        name: 'postesglobals',
        component: () => AllViews.ReadPostesglobals(),
        meta: {
            pageTitle: 'Postesglobals',
            breadcrumb: [
                {
                    text: 'Postesglobals',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/postespointeuses',
        name: 'postespointeuses',
        component: () => AllViews.ReadPostespointeuses(),
        meta: {
            pageTitle: 'Postespointeuses',
            breadcrumb: [
                {
                    text: 'Postespointeuses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/postestats',
        name: 'postestats',
        component: () => AllViews.ReadPostestats(),
        meta: {
            pageTitle: 'Postestats',
            breadcrumb: [
                {
                    text: 'Postestats',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/presence_par_date',
        name: 'presence_par_date',
        component: () => AllViews.ReadPresence_par_date(),
        meta: {
            pageTitle: 'Presence_par_date',
            breadcrumb: [
                {
                    text: 'Presence_par_date',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/presences',
        name: 'presences',
        component: () => AllViews.ReadPresences(),
        meta: {
            pageTitle: 'Presences',
            breadcrumb: [
                {
                    text: 'Presences',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/preuves',
        name: 'preuves',
        component: () => AllViews.ReadPreuves(),
        meta: {
            pageTitle: 'Preuves',
            breadcrumb: [
                {
                    text: 'Preuves',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/programmations',
        name: 'programmations',
        component: () => AllViews.ReadProgrammations(),
        meta: {
            pageTitle: 'Programmations',
            breadcrumb: [
                {
                    text: 'Programmations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/programmes',
        name: 'programmes',
        component: () => AllViews.ReadProgrammes(),
        meta: {
            pageTitle: 'Programmes',
            breadcrumb: [
                {
                    text: 'Programmes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/projets',
        name: 'projets',
        component: () => AllViews.ReadProjets(),
        meta: {
            pageTitle: 'Projets',
            breadcrumb: [
                {
                    text: 'Projets',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/provinces',
        name: 'provinces',
        component: () => AllViews.ReadProvinces(),
        meta: {
            pageTitle: 'Provinces',
            breadcrumb: [
                {
                    text: 'Provinces',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rapportpostes',
        name: 'rapportpostes',
        component: () => AllViews.ReadRapportpostes(),
        meta: {
            pageTitle: 'Rapportpostes',
            breadcrumb: [
                {
                    text: 'Rapportpostes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/rapportsautomatiques',
        name: 'rapportsautomatiques',
        component: () => AllViews.ReadRapportsautomatiques(),
        meta: {
            pageTitle: 'Rapportsautomatiques',
            breadcrumb: [
                {
                    text: 'Rapportsautomatiques',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/reservations',
        name: 'reservations',
        component: () => AllViews.ReadReservations(),
        meta: {
            pageTitle: 'Reservations',
            breadcrumb: [
                {
                    text: 'Reservations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/role_has_permission',
        name: 'role_has_permission',
        component: () => AllViews.ReadRole_has_permission(),
        meta: {
            pageTitle: 'Role_has_permission',
            breadcrumb: [
                {
                    text: 'Role_has_permission',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/role_has_permissions',
        name: 'role_has_permissions',
        component: () => AllViews.ReadRole_has_permissions(),
        meta: {
            pageTitle: 'Role_has_permissions',
            breadcrumb: [
                {
                    text: 'Role_has_permissions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/roles',
        name: 'roles',
        component: () => AllViews.ReadRoles(),
        meta: {
            pageTitle: 'Roles',
            breadcrumb: [
                {
                    text: 'Roles',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/serveurswebs',
        name: 'serveurswebs',
        component: () => AllViews.ReadServeurswebs(),
        meta: {
            pageTitle: 'Serveurswebs',
            breadcrumb: [
                {
                    text: 'Serveurswebs',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/services',
        name: 'services',
        component: () => AllViews.ReadServices(),
        meta: {
            pageTitle: 'Services',
            breadcrumb: [
                {
                    text: 'Services',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sexes',
        name: 'sexes',
        component: () => AllViews.ReadSexes(),
        meta: {
            pageTitle: 'Sexes',
            breadcrumb: [
                {
                    text: 'Sexes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sites',
        name: 'sites',
        component: () => AllViews.ReadSites(),
        meta: {
            pageTitle: 'Sites',
            breadcrumb: [
                {
                    text: 'Sites',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sitesglobals',
        name: 'sitesglobals',
        component: () => AllViews.ReadSitesglobals(),
        meta: {
            pageTitle: 'Sitesglobals',
            breadcrumb: [
                {
                    text: 'Sitesglobals',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sitespointeuses',
        name: 'sitespointeuses',
        component: () => AllViews.ReadSitespointeuses(),
        meta: {
            pageTitle: 'Sitespointeuses',
            breadcrumb: [
                {
                    text: 'Sitespointeuses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sitessdeplacements',
        name: 'sitessdeplacements',
        component: () => AllViews.ReadSitessdeplacements(),
        meta: {
            pageTitle: 'Sitessdeplacements',
            breadcrumb: [
                {
                    text: 'Sitessdeplacements',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sitessuperviseurs',
        name: 'sitessuperviseurs',
        component: () => AllViews.ReadSitessuperviseurs(),
        meta: {
            pageTitle: 'Sitessuperviseurs',
            breadcrumb: [
                {
                    text: 'Sitessuperviseurs',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/situations',
        name: 'situations',
        component: () => AllViews.ReadSituations(),
        meta: {
            pageTitle: 'Situations',
            breadcrumb: [
                {
                    text: 'Situations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/soldables',
        name: 'soldables',
        component: () => AllViews.ReadSoldables(),
        meta: {
            pageTitle: 'Soldables',
            breadcrumb: [
                {
                    text: 'Soldables',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/statszones',
        name: 'statszones',
        component: () => AllViews.ReadStatszones(),
        meta: {
            pageTitle: 'Statszones',
            breadcrumb: [
                {
                    text: 'Statszones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/supportclientreponses',
        name: 'supportclientreponses',
        component: () => AllViews.ReadSupportclientreponses(),
        meta: {
            pageTitle: 'Supportclientreponses',
            breadcrumb: [
                {
                    text: 'Supportclientreponses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/supportclientrequettes',
        name: 'supportclientrequettes',
        component: () => AllViews.ReadSupportclientrequettes(),
        meta: {
            pageTitle: 'Supportclientrequettes',
            breadcrumb: [
                {
                    text: 'Supportclientrequettes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/surveillances',
        name: 'surveillances',
        component: () => AllViews.ReadSurveillances(),
        meta: {
            pageTitle: 'Surveillances',
            breadcrumb: [
                {
                    text: 'Surveillances',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/switchsusers',
        name: 'switchsusers',
        component: () => AllViews.ReadSwitchsusers(),
        meta: {
            pageTitle: 'Switchsusers',
            breadcrumb: [
                {
                    text: 'Switchsusers',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/terminals',
        name: 'terminals',
        component: () => AllViews.ReadTerminals(),
        meta: {
            pageTitle: 'Terminals',
            breadcrumb: [
                {
                    text: 'Terminals',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/trackings',
        name: 'trackings',
        component: () => AllViews.ReadTrackings(),
        meta: {
            pageTitle: 'Trackings',
            breadcrumb: [
                {
                    text: 'Trackings',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/traitements',
        name: 'traitements',
        component: () => AllViews.ReadTraitements(),
        meta: {
            pageTitle: 'Traitements',
            breadcrumb: [
                {
                    text: 'Traitements',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/trajets',
        name: 'trajets',
        component: () => AllViews.ReadTrajets(),
        meta: {
            pageTitle: 'Trajets',
            breadcrumb: [
                {
                    text: 'Trajets',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/transactions',
        name: 'transactions',
        component: () => AllViews.ReadTransactions(),
        meta: {
            pageTitle: 'Transactions',
            breadcrumb: [
                {
                    text: 'Transactions',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/transactionsuserssyntheses2',
        name: 'transactionsuserssyntheses2',
        component: () => AllViews.ReadTransactionsuserssyntheses2(),
        meta: {
            pageTitle: 'Transactionsuserssyntheses2',
            breadcrumb: [
                {
                    text: 'Transactionsuserssyntheses2',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/types',
        name: 'types',
        component: () => AllViews.ReadTypes(),
        meta: {
            pageTitle: 'Types',
            breadcrumb: [
                {
                    text: 'Types',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typesabscences',
        name: 'typesabscences',
        component: () => AllViews.ReadTypesabscences(),
        meta: {
            pageTitle: 'Typesabscences',
            breadcrumb: [
                {
                    text: 'Typesabscences',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typesagentshoraires',
        name: 'typesagentshoraires',
        component: () => AllViews.ReadTypesagentshoraires(),
        meta: {
            pageTitle: 'Typesagentshoraires',
            breadcrumb: [
                {
                    text: 'Typesagentshoraires',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typeseffectifs',
        name: 'typeseffectifs',
        component: () => AllViews.ReadTypeseffectifs(),
        meta: {
            pageTitle: 'Typeseffectifs',
            breadcrumb: [
                {
                    text: 'Typeseffectifs',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typesheures',
        name: 'typesheures',
        component: () => AllViews.ReadTypesheures(),
        meta: {
            pageTitle: 'Typesheures',
            breadcrumb: [
                {
                    text: 'Typesheures',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typesmarchandises',
        name: 'typesmarchandises',
        component: () => AllViews.ReadTypesmarchandises(),
        meta: {
            pageTitle: 'Typesmarchandises',
            breadcrumb: [
                {
                    text: 'Typesmarchandises',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typesmoyenstransports',
        name: 'typesmoyenstransports',
        component: () => AllViews.ReadTypesmoyenstransports(),
        meta: {
            pageTitle: 'Typesmoyenstransports',
            breadcrumb: [
                {
                    text: 'Typesmoyenstransports',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typespointages',
        name: 'typespointages',
        component: () => AllViews.ReadTypespointages(),
        meta: {
            pageTitle: 'Typespointages',
            breadcrumb: [
                {
                    text: 'Typespointages',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typespointeuses',
        name: 'typespointeuses',
        component: () => AllViews.ReadTypespointeuses(),
        meta: {
            pageTitle: 'Typespointeuses',
            breadcrumb: [
                {
                    text: 'Typespointeuses',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typespostes',
        name: 'typespostes',
        component: () => AllViews.ReadTypespostes(),
        meta: {
            pageTitle: 'Typespostes',
            breadcrumb: [
                {
                    text: 'Typespostes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typessites',
        name: 'typessites',
        component: () => AllViews.ReadTypessites(),
        meta: {
            pageTitle: 'Typessites',
            breadcrumb: [
                {
                    text: 'Typessites',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/typesventilations',
        name: 'typesventilations',
        component: () => AllViews.ReadTypesventilations(),
        meta: {
            pageTitle: 'Typesventilations',
            breadcrumb: [
                {
                    text: 'Typesventilations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/users',
        name: 'users',
        component: () => AllViews.ReadUsers(),
        meta: {
            pageTitle: 'Users',
            breadcrumb: [
                {
                    text: 'Users',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/userszones',
        name: 'userszones',
        component: () => AllViews.ReadUserszones(),
        meta: {
            pageTitle: 'Userszones',
            breadcrumb: [
                {
                    text: 'Userszones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/vacations',
        name: 'vacations',
        component: () => AllViews.ReadVacations(),
        meta: {
            pageTitle: 'Vacations',
            breadcrumb: [
                {
                    text: 'Vacations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/vacations2',
        name: 'vacations2',
        component: () => AllViews.ReadVacations2(),
        meta: {
            pageTitle: 'Vacations2',
            breadcrumb: [
                {
                    text: 'Vacations2',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/validations',
        name: 'validations',
        component: () => AllViews.ReadValidations(),
        meta: {
            pageTitle: 'Validations',
            breadcrumb: [
                {
                    text: 'Validations',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/variables',
        name: 'variables',
        component: () => AllViews.ReadVariables(),
        meta: {
            pageTitle: 'Variables',
            breadcrumb: [
                {
                    text: 'Variables',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/villes',
        name: 'villes',
        component: () => AllViews.ReadVilles(),
        meta: {
            pageTitle: 'Villes',
            breadcrumb: [
                {
                    text: 'Villes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/villeszones',
        name: 'villeszones',
        component: () => AllViews.ReadVilleszones(),
        meta: {
            pageTitle: 'Villeszones',
            breadcrumb: [
                {
                    text: 'Villeszones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/voyages',
        name: 'voyages',
        component: () => AllViews.ReadVoyages(),
        meta: {
            pageTitle: 'Voyages',
            breadcrumb: [
                {
                    text: 'Voyages',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/websockets_statistics_entries',
        name: 'websockets_statistics_entries',
        component: () => AllViews.ReadWebsockets_statistics_entries(),
        meta: {
            pageTitle: 'Websockets_statistics_entries',
            breadcrumb: [
                {
                    text: 'Websockets_statistics_entries',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/works',
        name: 'works',
        component: () => AllViews.ReadWorks(),
        meta: {
            pageTitle: 'Works',
            breadcrumb: [
                {
                    text: 'Works',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/zones',
        name: 'zones',
        component: () => AllViews.ReadZones(),
        meta: {
            pageTitle: 'Zones',
            breadcrumb: [
                {
                    text: 'Zones',
                    active: true,
                },
            ],
        },
    },

];

export default routes;
